import React from "react";
import ManagerBusView from "./ManagerBusView";

function ManagerBusList(props) {
  const { ads, tapes, bus, setBus, search, setSearch, reload, setReload } =
    props;
  const buses = tapes.reduce((pre, cur) => {
    if (pre.get(cur.busNumber)) {
      pre.get(cur.busNumber).push(cur);
    } else {
      pre.set(cur.busNumber, [cur]);
    }
    return pre;
  }, new Map());
  return (
    <div>
      {bus ? (
        <ManagerBusView
          tapes={buses.get(bus)}
          setBus={setBus}
          ads={ads}
          reload={reload}
          setReload={setReload}
        />
      ) : (
        <div className="bus-list">
          <input
            type={"number"}
            className={"search-field"}
            value={search.buses}
            placeholder={"Haku"}
            onChange={(event) => {
              setSearch({
                campaigns: search.campaigns,
                buses: event.target.value,
              });
            }}
          ></input>
          {Array.from(buses.values())
            .filter(
              (el) =>
                !Number(search.buses) ||
                String(el[0].busNumber).search(
                  RegExp(String(search.buses), "i")
                ) !== -1
            )
            .sort(
              (a, b) =>
                Number(a[0].busNumber.replace(/\D/g, "")) -
                Number(b[0].busNumber.replace(/\D/g, ""))
            )
            .map((el, index) => {
              return (
                <div
                  className="bus-entry"
                  key={index}
                  onClick={() => {
                    setBus(el[0].busNumber);
                  }}
                >
                  {el[0].busNumber +
                    " Teippauksia: " +
                    el.filter((el1) => el1.removed !== "X").length}
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
}

export default ManagerBusList;
